import { normalizeEmotion } from "../../utils/emotion";
import { mixHexColors, normalizeHexColor } from "./chunk-0.jsx";
import { normalizeChamiiVariant } from "./chunk-8.jsx";
export function pickChamiiCuteProfile(emotion, variant, accent) {
  const e = normalizeEmotion(emotion);
  const v = normalizeChamiiVariant(variant);
  const a = normalizeHexColor(accent) || '#FF5C5C';
  const sparkleColor = mixHexColors('#ffffff', a, 0.65);
  const baseLight = mixHexColors('#ffffff', a, 0.35);
  const baseDeep = mixHexColors('#111827', a, 0.55);
  const profile = {
    variant: v,
    gap: 12,
    openness: 0.78,
    irisScale: 0.62,
    pupilScale: 0.34,
    tilt: 0,
    lashes: !['macaron', 'sticker', 'mochi'].includes(v),
    sticker: v === 'sticker',
    sparkle: ['sparkle', 'rainbow', 'dreamy'].includes(v),
    blush: false,
    tear: false,
    winkLeft: false,
    pupilKind: 'round',
    accent: a,
    irisBg: `radial-gradient(circle at 30% 30%, rgba(255,255,255,0.75) 0%, ${baseLight} 34%, ${baseDeep} 100%)`,
    glow: false,
    glowColor: null,
    ring: false,
    jelly: false,
    boba: false,
    sprinkles: false,
    dreamy: false,
    pixel: false,
    sparkleColor
  };
  const tint = (hex, t = 0.25) => mixHexColors(hex, a, t);
  switch (v) {
    case 'sparkle':
      profile.irisScale = 0.66;
      profile.pupilScale = 0.32;
      profile.pupilKind = 'star';
      profile.gap = 13;
      profile.sparkle = true;
      profile.irisBg = `radial-gradient(circle at 30% 26%, rgba(255,255,255,0.85) 0%, ${tint('#f472b6', 0.32)} 28%, ${tint('#111827', 0.62)} 100%)`;
      break;
    case 'sticker':
      profile.irisScale = 0.64;
      profile.pupilScale = 0.38;
      profile.gap = 12;
      profile.lashes = false;
      profile.irisBg = `radial-gradient(circle at 30% 30%, rgba(255,255,255,0.8) 0%, ${tint('#60a5fa', 0.24)} 32%, ${tint('#111827', 0.55)} 100%)`;
      break;
    case 'jelly':
      profile.jelly = true;
      profile.irisScale = 0.68;
      profile.pupilScale = 0.3;
      profile.sparkle = true;
      profile.irisBg = `radial-gradient(circle at 30% 26%, rgba(255,255,255,0.92) 0%, ${tint('#22d3ee', 0.32)} 32%, rgba(15,23,42,0.9) 100%)`;
      break;
    case 'kitty':
      profile.pupilKind = 'slit';
      profile.sparkle = true;
      profile.irisBg = `radial-gradient(circle at 34% 28%, rgba(255,255,255,0.84) 0%, ${tint('#f472b6', 0.28)} 34%, rgba(15,23,42,0.92) 100%)`;
      break;
    case 'boba':
      profile.boba = true;
      profile.sparkle = true;
      profile.irisBg = `radial-gradient(circle at 30% 28%, rgba(255,255,255,0.82) 0%, ${tint('#f59e0b', 0.28)} 34%, rgba(15,23,42,0.92) 100%)`;
      break;
    case 'rainbow':
      {
        const stops = [tint('#60a5fa', 0.2), tint('#a78bfa', 0.18), tint('#fb7185', 0.18), tint('#fbbf24', 0.18), tint('#34d399', 0.18), tint('#60a5fa', 0.2)];
        profile.sparkle = true;
        profile.irisBg = `radial-gradient(circle at 30% 26%, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0) 36%), conic-gradient(from 90deg, ${stops.join(', ')})`;
        break;
      }
    case 'choco':
      profile.sprinkles = true;
      profile.sparkle = false;
      profile.irisBg = `radial-gradient(circle at 30% 26%, rgba(255,255,255,0.82) 0%, ${tint('#92400e', 0.26)} 34%, rgba(15,23,42,0.95) 100%)`;
      break;
    case 'mochi':
      profile.ring = true;
      profile.lashes = false;
      profile.sparkle = true;
      profile.irisBg = `radial-gradient(circle at 30% 26%, rgba(255,255,255,0.9) 0%, ${tint('#fda4af', 0.22)} 34%, ${tint('#111827', 0.48)} 100%)`;
      break;
    case 'neon':
      profile.glow = true;
      profile.glowColor = tint('#40E0D0', 0.42);
      profile.sparkle = true;
      profile.irisBg = `radial-gradient(circle at 30% 26%, rgba(255,255,255,0.85) 0%, ${tint('#22c55e', 0.26)} 34%, rgba(15,23,42,0.95) 100%)`;
      break;
    case 'dreamy':
      profile.dreamy = true;
      profile.sparkle = true;
      profile.irisBg = `radial-gradient(circle at 30% 22%, rgba(255,255,255,0.92) 0%, rgba(255,255,255,0.05) 34%), radial-gradient(circle at 70% 80%, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 44%), conic-gradient(from 110deg, ${tint('#60a5fa', 0.22)}, ${tint('#a78bfa', 0.2)}, ${tint('#fb7185', 0.2)}, ${tint('#34d399', 0.2)}, ${tint('#60a5fa', 0.22)})`;
      break;
    case 'pixel':
      profile.pixel = true;
      profile.irisScale = 0.7;
      profile.pupilScale = 0.26;
      profile.sparkle = true;
      profile.irisBg = `radial-gradient(circle at 30% 26%, rgba(255,255,255,0.86) 0%, ${tint('#38bdf8', 0.22)} 34%, rgba(15,23,42,0.92) 100%)`;
      break;
    case 'macaron':
    default:
      break;
  }
  switch (e) {
    case 'laughing':
      profile.openness = 0.18;
      profile.pupilKind = 'line';
      profile.sparkle = true;
      break;
    case 'sleepy':
      profile.openness = 0.22;
      profile.pupilScale = Math.min(profile.pupilScale, 0.26);
      if (profile.pupilKind === 'star') profile.pupilKind = 'round';
      break;
    case 'angry':
      profile.openness = 0.46;
      profile.tilt = 16;
      profile.pupilKind = 'slit';
      profile.blush = v !== 'sparkle';
      break;
    case 'sad':
      profile.openness = 0.52;
      if (profile.pupilKind === 'star') profile.pupilKind = 'round';
      profile.tear = true;
      break;
    case 'surprised':
      profile.openness = 0.96;
      profile.pupilScale = 0.18;
      profile.pupilKind = 'round';
      profile.sparkle = true;
      break;
    case 'loving':
      profile.openness = 0.8;
      profile.pupilKind = 'heart';
      profile.blush = true;
      profile.sparkle = true;
      break;
    case 'embarrassed':
      profile.blush = true;
      profile.sparkle = true;
      break;
    case 'winking':
      profile.winkLeft = true;
      profile.sparkle = true;
      break;
    case 'confused':
      profile.tilt = 6;
      if (profile.pupilKind === 'star') profile.pupilKind = 'round';
      break;
    case 'thinking':
      profile.tilt = 4;
      profile.sparkle = true;
      break;
    case 'cool':
      profile.sparkle = true;
      break;
    case 'relaxed':
      profile.openness = 0.5;
      profile.pupilKind = 'round';
      break;
    case 'silly':
      profile.winkLeft = true;
      profile.sparkle = true;
      break;
    case 'confident':
      profile.sparkle = true;
      break;
    case 'delicious':
      profile.sparkle = true;
      profile.blush = true;
      break;
    case 'happy':
      profile.sparkle = true;
      break;
    case 'neutral':
    default:
      break;
  }
  if (v === 'kitty' && profile.pupilKind === 'round') profile.pupilKind = 'slit';
  if (v === 'pixel' && profile.pupilKind === 'slit') profile.pupilKind = 'round';
  if (v === 'choco' && profile.sparkle) profile.sparkle = false;
  if (v === 'sticker' && profile.sparkle) profile.sparkle = false;
  return profile;
}
